import React, { Component } from 'react';
import { connect } from 'react-redux';

import { translate } from "../../translate";
import "./style.css";

class Footer extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }


    render() {
        let activeUser =  this.props.activeUser ;
        return (
            <div id="footer">
                <b>{translate("Usuário logado:")} { activeUser && activeUser.name ? activeUser.name : translate("footer.cliente", "Cliente") }</b>
            </div>
        )
    }
}

// "state" is set in reducers/index.js
function mapStateToProps(state) {
    return {
        activeUser : state.activeUser
    };
}
export default connect(mapStateToProps)(Footer);